import React, { Component } from 'react';
import PropTypes from 'prop-types';


import classNames from 'classnames';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import HelpIcon from '@mui/icons-material/Help';
import GuideIcon from '@mui/icons-material/Book';
import ReportIcon from '@mui/icons-material/Report';
import SupportIcon from '@mui/icons-material/ContactSupport';
import ViewModule from '@mui/icons-material/ViewModule';
//import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
//import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import SearchBox from './SearchBox';
import { ChevronLeft, ChevronRight, SettingsApplications } from '@mui/icons-material';
import { Box, type Theme } from '@mui/material';

const drawerWidth = 240;
const miniDrawerWidth = 60;

const s:any = {
  //console.log('theme in header: ',theme);
  //return ({
    appBar: (theme:Theme)=>({
      zIndex: 'zIndex.drawer + 1',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    }),
    appBarShift: (theme:Theme)=>({
      [theme.breakpoints.down('sm')]:{
        width: `calc(100% - ${miniDrawerWidth}px)`,
        marginLeft: miniDrawerWidth,
      },
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
    toolbar:{
      display: 'flex',
      justifyContent: 'flex-end'
    },
    searchbar: {
      width:'100%'
    },
    menuButton: {
      marginLeft: 2,
      marginRight: 4,
      position:'absolute',
      left:1
    },
    hide: {
      display: 'none',
    },
    show: {
      display: 'flex',
    },
    topmenu: {
      float: 'right'
    },
    title: {
      marginLeft: 4,
      marginRight: 1,
      position:'absolute',
      left:40,
      color:'white',
      flexGrow: 1, 
      display: { xs: 'none', sm: 'block' } 
    }
  //});
};

class Header extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      anchorEl: null,
      menuopen: false,
      useropen: false,
      useranchor: null,
      settingsopen: false,
      settingsanchor: null,
    };
  }

  handleClick = (menu:any,page:any,index:any)=> () => {
    console.log('handleclick:menu,page,index',menu,page,index);
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
    
  };

  onUserOpen = (event:any) => {
    this.setState({ useranchor: event.currentTarget, useropen:true });
  };

  onUserProfile = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'profile';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserAccount = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'profile';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserAnnouncement = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'announcement';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onUserSignOut = (event:any) => {
    this.setState({ useranchor: null, useropen:false });
    const page = 'logout';
    this.props.handleSetContent(null,page).then( 
      () => {
      this.props.closeDrawer();
    },
    (reason:any) => {
      console.error(reason); // Error!
    }
  );
  };

  onUserClose = () => {
    this.setState({ useranchor: null, useropen:false });
  };

  onSettingsOpen = (event:any) => {
    this.setState({ settingsanchor: event.currentTarget, settingsopen:true });
  };

  onHelp = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onGuide = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'help';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onSupport = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'support';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onAbout = (event:any) => {
    this.setState({ settingsanchor: null, settingsopen:false });
    const page = 'about';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onSettingsClose = () => {
    this.setState({ settingsanchor: null, settingsopen:false });
  };

  onKeyPress = (event:any) => {
    if(event.key === 'Enter') this.onSearch(event.target.value);
  }

  onSearch = (query:any) => {
    const {page} = this.props;
    
    //const page = 'search';
    this.props.handleSetContent(query,page,true).then( () => {
      //clear search? no.
    });
  };

  onMenu = (event:any) => {
    this.setState({ anchorEl: event.currentTarget, menuopen:true });
    const page = 'kanban';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onMaintenance = (event:any) => {
    this.setState({ anchorEl: event.currentTarget, menuopen:true });
    const page = 'maintenance';
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
  };

  onClose = () => {
    this.setState({ anchorEl: null, menuopen:false });
  };

  render() {
    const {page, navDrawerOpen, openDrawer, closeDrawer, toggleDrawer, data, classes, theme} = this.props;
    const {onSearched} = this.props;
    const { useropen,useranchor,settingsopen,settingsanchor } = this.state;
    const eti = (data.bd||{}).eti;
    const isMain = (eti===1);
    const adminmenu = isMain?s.show:s.hide;

    //console.log("Entity id",eti)
    
    return (
      <Box sx={{ flexGrow: 1 }}>
      <AppBar
        sx={{
          width: navDrawerOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
          ...s.appBar, ...(navDrawerOpen?s.appBarShift:{}) 
        }}
        position={"absolute"}
        //position={"static"}
        // sx={{ }}
      >
        <Toolbar disableGutters={!navDrawerOpen} sx={{...s.toolbar}}>
          <IconButton
            color="inherit"
            sx={{
              position: "absolute",...s.menuButton
            }}
            aria-label="open drawer"
            //onClick={navDrawerOpen?openDrawer:closeDrawer}
            onClick={toggleDrawer}
            //className={classNames(classes.menuButton, navDrawerOpen && classes.hide)}
            //sx={{...s.menuButton}}
            size="large"
            edge="start"
            //color="inherit"
            //aria-label="open drawer"
            //sx={{ mr: 2 }}
          >
            {navDrawerOpen ? (
              <ChevronLeft />
            ) : (
              <MenuIcon />
            )}
          {/* <MenuIcon /> */}
          </IconButton>
          <Typography sx={{...s.title}} variant="h6" noWrap>
             {data.bd.enm}
          </Typography>
          {/* <SearchBox sx={{...s.searchbar}} page={page} onKeyPress={this.onKeyPress} onSearched={onSearched}/> */}
          <Box sx={{...s.topmenu}}>{/*HeaderMenu  style={style.iconsRightContainer}....marginLeft:20*/}
            <IconButton
              aria-owns={settingsopen ? 'menu' : undefined}
              aria-haspopup={true}
              onClick={this.onMenu}
              color="inherit">
              <ViewModule />
            </IconButton>
            {/* {
              adminmenu ? <IconButton
                aria-owns={settingsopen ? 'maintenance' : undefined}
                aria-haspopup={true}
                onClick={this.onMaintenance}
                color="inherit">
                <SettingsApplications />
              </IconButton>:null
            } */}
            {/* <Menu
              id="menu-setting"
              anchorEl={settingsanchor}
              anchorOrigin={{vertical: 'top', horizontal: 'right'}}
              transformOrigin={{vertical: 'top', horizontal: 'right'}}
              open={settingsopen}
              onClose={this.onSettingsClose}>
              <MenuItem onClick={this.onSettingsClose}><HelpIcon/>Help</MenuItem>
              <MenuItem onClick={this.onSettingsClose}><GuideIcon/>User Guide</MenuItem>
              <MenuItem onClick={this.onSettingsClose}><SupportIcon/>Support</MenuItem>
              <MenuItem onClick={this.onSettingsClose} className={adminmenu}><ReportIcon/>Reports</MenuItem>
            </Menu> */}
          </Box>
          <Box sx={{...s.topmenu}}>{/*HelpMenu  style={style.iconsRightContainer}....marginLeft:20*/}
            <IconButton
              aria-owns={settingsopen ? 'help-menu' : undefined}
              aria-haspopup="true"
              onClick={this.onSettingsOpen}
              color="inherit">
              <MenuIcon />
            </IconButton>
            <Menu
              id="help-menu"
              anchorEl={settingsanchor}
              anchorOrigin={{vertical: 'top', horizontal: 'right'}}
              transformOrigin={{vertical: 'top', horizontal: 'right'}}
              open={settingsopen}
              onClose={this.onSettingsClose}>
              <MenuItem onClick={this.onHelp}><HelpIcon/>Help</MenuItem>
              <MenuItem onClick={this.onGuide}><GuideIcon/>User Guide</MenuItem>
              <MenuItem onClick={this.onSupport}><SupportIcon/>Support</MenuItem>
              {/* <MenuItem onClick={this.onClose} sx={{...adminmenu}}><ReportIcon/>Reports</MenuItem> */}
            </Menu>
          </Box>
          <Box>{/* UserMenu*/}
            <IconButton
              aria-owns={useropen ? 'menu-user' : undefined}
              aria-haspopup="true"
              onClick={this.onUserOpen}
              color="inherit">
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-user"
              anchorEl={useranchor}
              anchorOrigin={{vertical: 'top', horizontal: 'right'}}
              transformOrigin={{vertical: 'top', horizontal: 'right'}}
              open={useropen}
              onClose={this.onUserClose}
            >
              {/* <MenuItem onClick={this.onUserProfile}>Profile</MenuItem> */}
              <MenuItem onClick={this.onUserAccount}>My Account</MenuItem>
              <MenuItem onClick={this.onUserAnnouncement}>Announcement</MenuItem>
              <MenuItem onClick={this.onUserSignOut}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      </Box>
    );
  }
}

Header.propTypes = {
  hstyles: PropTypes.object,
  toggleDrawer: PropTypes.func
};

//export default Header;
export default Header;
